import * as React from "react";
import { Hotspot, TourData } from "../../../Types";
import WaypointExpIcon from "../../Icons/WaypointExpIcon";
import { getLanguageFile } from "../../common/GetLanguageFile";

function Waypoint(props: { spot: Hotspot; tourData: TourData }) {
  const { spot, tourData } = props;

  const fillColor = React.useMemo(() => {
    const sceneIsMissing =
      !spot.target || !tourData.scenes.find((one) => one.id === spot.target);

    if (spot.isNew) return "#ff8700";
    else if (sceneIsMissing) return "red";
    else return "white";
  }, [spot, tourData]);

  return (
    <div className="hotspot waypoint">
      <WaypointExpIcon className={"waypoint " + spot.dir} color={fillColor} />

      {spot.isNew && !spot.EDIT_POS && <p>Non salvato</p>}
      {!spot.isNew && !spot.EDIT_POS && (
        <>
          {spot.target &&
          tourData.scenes.find((one) => one.id === spot.target) ? (
            <p>
              {tourData.scenes.find((one) => one.id === spot.target)!.title}
            </p>
          ) : (
            <p style={{ color: "red" }}>
              {getLanguageFile("hotspots.missing_scene")}
            </p>
          )}
        </>
      )}
      {!spot.isNew && !spot.target && (
        <p style={{ color: "red" }}>
          {getLanguageFile("hotspots.missing_scene")}
        </p>
      )}
    </div>
  );
}

export default Waypoint;
